import { Injectable, Injector, inject } from '@angular/core'
import {
  HttpResponse,
  type HttpEvent,
  type HttpHandler,
  type HttpInterceptor,
  type HttpRequest
} from '@angular/common/http'
import { tap, type Observable } from 'rxjs'
import { apiEndpoint } from '@awork/environments/environment'
import { UndoService } from '../undo-service/undo.service'

@Injectable()
export class UndoResponseInterceptor implements HttpInterceptor {
  private readonly injector = inject(Injector)
  /**
   * Registers undo metadata returned by an API response.
   * @param {HttpRequest<unknown>} req - The outgoing API request.
   * @param {HttpHandler} next - The next request handler.
   * @returns {Observable<HttpEvent<unknown>>} The response events.
   */
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap(event => {
        if (!(event instanceof HttpResponse)) {
          return
        }

        const id = event.headers.get('aw-undo-id')

        if (!event.ok) {
          return
        }

        if (!id) {
          if (req.url.startsWith(apiEndpoint) && ['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method)) {
            this.injector.get(UndoService).noteMutation(req, event)
          }

          return
        }

        this.injector.get(UndoService).register({
          id,
          type: event.headers.get('aw-undo-type') ?? 'generic',
          count: Number(event.headers.get('aw-undo-count')) || 1,
          groupId: event.headers.get('aw-undo-group'),
          request: req
        })
      })
    )
  }
}
